import React, { useState, SyntheticEvent, useEffect, useMemo } from 'react'
import classnames from 'classnames'
import ValueCard, { ICarReview } from './value-card'
import getUrl from 'lib/url'
import fetch from 'lib/decorated-fetch'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { logger } from 'lib/slardar-utils'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import { useResponsive } from 'Components/hooks/use-responsive'
import SwiperButton from 'Components/swiper-button'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import TryCatchRender from 'Components/try-catch-render'

SwiperCore.use([Navigation])

import Title from './title'

export const dcarScoreData = async (req: any) => {
  const params = {
    limousine_num: 12,
    suv_num: 8,
    mpv_num: 8,
    energy_num: 8,
    total_num: 36,
  }

  const json = await fetch(
    getUrl(`/motor/pc/content/pc_car_reviews?${serializeObject(params)}`),
    {
      req,
    }
  ).catch((error) => {
    logger.warn(`[fetch] dCarScore error. err=${error.message}`)
    return []
  })
  let data = json?.data || []
  if (!Array.isArray(data)) {
    data = []
  }
  return data
}

// is_new_energy?: boolean;  // 是否是新能源 前端处理
// series_type?: number;  //车系类型 0 轿车 1 suv 2 mvp
// 数据切换：切换不固定次数，确保不丢弃数据
// - 5列（1920）：5列*6切 =30个内容（最大值）;轿车-2、suv-1、新能源-1、mpv-1
// - 4列（1680/1440/1280/1024）：4列*8切 ， 满足30（最大值）; 轿车-1、suv-1、新能源-1、mpv-1

// 通过一个配置遍历获取
interface IConfig {
  [key: string]: {
    page: number
    types: number[]
  }
}
const MAX_LENGTH = 30 //
const pageConfig: IConfig = {
  5: {
    page: 6,
    types: [2, 1, 1, 1], // 轿车、suv、新能源、mvp
  },
  4: {
    page: 8,
    types: [1, 1, 1, 1],
  },
}

const defaultNum = 4

export default TryCatchRender(function DongCheFen() {
  const [picNum, setPicNum] = useState<number>(defaultNum)

  const responsive = useResponsive()

  const computedCarList = (num: number, carList: ICarReview[]) => {
    const typeList: ICarReview[][] = [[], [], []]
    const newEnergy: ICarReview[] = []
    carList.forEach((item) => {
      if (item.is_new_energy) {
        newEnergy.push(item)
      } else {
        if (typeList[item.series_type]) {
          typeList[item.series_type].push(item)
        }
      }
    })
    // 新能源顺序的第三个
    typeList.splice(2, 0, newEnergy)
    let result: ICarReview[] = []
    let isContinue = true
    let times = 0
    const currentPageConfig = pageConfig[num]
    while (isContinue) {
      let isAdd = true // 必须遍历添加完整的一组数组
      let tmp: ICarReview[] = []
      currentPageConfig.types.forEach((value, index) => {
        if (typeList[index].length < value) {
          isAdd = false
          return
        }
        tmp = tmp.concat(typeList[index].splice(0, value))
      })
      if (isAdd) {
        result = result.concat(tmp)
        times++
      } else {
        isContinue = false
      }
      if (result.length >= MAX_LENGTH) {
        isContinue = false
      }
    }
    return { result, times }
  }

  const [frameTimes, setFrameTimes] = useState(0)
  const [swiperCarList, setSwiperCarList] = useState<ICarReview[]>([])

  const [swiper, setSwiper] = useState<any>(null)
  const navigationPrevRef = React.useRef(null)
  const navigationNextRef = React.useRef(null)

  const [defaultData, setDefaultData] = useState([])
  useEffect(() => {
    async function init() {
      try {
        const data = await dcarScoreData(null)
        setDefaultData(data)
      } catch (error) {
        logger.warn(`[fetch] dCarScore error. err=${error.message}`)
      }
    }
    init()
  }, [])

  useEffect(() => {
    let num = defaultNum
    if (responsive['2xl']) {
      num = defaultNum + 1
    }
    const { result, times } = computedCarList(num, defaultData)
    setSwiperCarList(result)
    setFrameTimes(times)
    setPicNum(num)

    if (swiper && swiper.slideTo) {
      // eslint-disable-next-line no-unused-expressions
      swiper?.slideTo(0)
    }
  }, [responsive?.['2xl'], defaultData])

  const breakpoints = {
    1920: {
      slidesPerView: 5,
      slidesPerGroup: 5,
    },
  }

  function renderSwiper() {
    return (
      <Swiper
        slidesPerGroup={4}
        slidesPerView={4}
        breakpoints={breakpoints}
        spaceBetween={12}
        watchOverflow={true}
        preventClicks={false}
        observeParents={true}
        observer={true}
        resizeObserver={true}
        navigation={{
          nextEl: navigationNextRef.current,
          prevEl: navigationPrevRef.current,
        }}
        onSwiper={setSwiper}
        simulateTouch={false}
        loop={false}
        onSlideChangeTransitionStart={(swiper) => {
          sendTeaCommEvent('clk_event', {
            event_id: 'dscore_module_change',
            module_id: 'dscore_module',
          })
        }}
      >
        {new Array(frameTimes)
          .fill(undefined)
          .map((item: number, index: number) => {
            const currentIndex = index * picNum
            const currectList = swiperCarList.slice(
              currentIndex,
              currentIndex + picNum
            )
            return (
              <div key={`${currentIndex}-${index}`}>
                {currectList?.map((e, i) => (
                  <SwiperSlide key={`${currentIndex}-${index}-${i}`}>
                    <ValueCard
                      {...e}
                      key={`${e?.series_id}-${e?.author_info?.user_id}-${index}`}
                      rank={index}
                      item_rank={i}
                    />
                  </SwiperSlide>
                ))}
              </div>
            )
          })}
      </Swiper>
    )
  }

  function renderBg() {
    return (
      <div className="bg-wrap tw-grid tw-grid-cols-4 tw-gap-x-12 2xl:tw-grid-cols-5">
        {new Array(5).fill(undefined).map((item, index) => {
          return (
            <div
              key={`bg-${index}`}
              className={classnames({
                'bg-item': true,
                'g-load-img-wrap': true,
                'tw-hidden': index >= 4,
                '2xl:tw-block': index >= 4,
              })}
            />
          )
        })}
        <style jsx>
          {`
            .bg-wrap {
              padding-top: 52px;
            }
            .bg-item {
              height: 342px;
            }
          `}
        </style>
      </div>
    )
  }

  return (
    <div className="wrapper-car-review tw-grid tw-grid-cols-12 tw-gap-x-12 tw-w-full">
      <div className="top-bar">
        <span
          className="title"
          onClick={() => {
            sendTeaCommEvent('clk_event', {
              event_id: 'dscore_module_title',
              module_id: 'dscore_module',
            })
          }}
        />
        <Title />
        <SwiperButton
          ref={navigationPrevRef}
          type="prev"
          buttonStyle={{
            justifySelf: 'flex-end',
            marginLeft: 'auto',
          }}
        />
        <SwiperButton
          ref={navigationNextRef}
          type="next"
          buttonStyle={{
            justifySelf: 'flex-end',
          }}
        />
      </div>
      <div className="car-review-swiper tw-col-span-12">
        {swiperCarList.length ? renderSwiper() : renderBg()}
      </div>
      <style jsx>
        {`
          :global(.wrapper-car-review .swiper-container) {
            padding-top: 55px;
            height: 302px;
            box-sizing: content-box;
          }
          .wrapper-car-review {
            position: relative;
            width: 100%;
            border-radius: 2px;
            padding: 5px 0 0 0;
          }
          .background {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .top-bar {
            height: 34px;
            width: 100%;
            position: absolute;
            z-index: 9;
            top: 15px;
            display: flex;
            align-items: center;
          }
          .card-wrapper {
            overflow: hidden;
            width: 100%;
          }
          .logo {
            width: 85px;
            height: 34px;
            object-fit: contain;
            margin-right: 21px;
          }
          .title {
            display: inline-block;
            width: 75px;
            height: 30px;
            background-image: url(${require('static/dcar-score-black.png')});
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100%;
            margin-right: 16px;
            border-radius: 2px;
          }
          :global(.wrapper-car-review .text) {
            font-size: 14px;
            color: #606370;
          }
          .change-ic {
            font-size: 16px;
            color: white;
            justify-self: flex-end;
            margin-left: auto;
            cursor: pointer;
          }
          .change-ic img {
            width: 12px;
            height: 12px;
            object-fit: contain;
            margin-left: 4px;
          }
        `}
      </style>
    </div>
  )
})
